import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { MarketersDashboard } from '../../../features/marketers'
import { MarketerDetail } from '../../../features/marketers/components/detail/marketers-detail.component'

export const MarketersPage = () => {
  return (
    <Routes>
      <Route index element={<MarketersDashboard />} />
      <Route path=":marketerId" element={<MarketerDetail />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  )
}
